"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { DialogContent, DialogOverlay } from "@/components/rac/dialog";
import { SheetContent, SheetHeader, SheetOverlay } from "@/components/rac/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
interface ValidationPrerequisitesModalProps {
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  validationErrors: string[];
  showModal?: boolean; // If false, renders inline without modal wrapper
  errorMessage?: string;
}
export function ValidationPrerequisitesModal(t0) {
  const $ = _c(31);
  const {
    isOpen: t1,
    onOpenChange,
    validationErrors,
    showModal: t2,
    errorMessage
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const showModal = t2 === undefined ? true : t2;
  const isMobile = useIsMobile();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex-shrink-0"><svg className="w-6 h-6 text-red-600" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h3 className="text-lg font-semibold text-red-900 mb-3">Missing Required Data</h3>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = errorMessage || "Before confirming your fee agreement, please complete the following:";
  let t6;
  if ($[2] !== t5) {
    t6 = <p className="text-red-800 mb-3 leading-relaxed">{t5}</p>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== validationErrors) {
    t7 = validationErrors.map(_temp);
    $[4] = validationErrors;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t7) {
    t8 = <ul className="space-y-2">{t7}</ul>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t6 || $[9] !== t8) {
    t9 = <div className="bg-gradient-to-br from-red-50 to-rose-50 border border-red-300 rounded-xl p-5 shadow-sm"><div className="flex items-start space-x-3">{t3}<div className="flex-1">{t4}{t6}{t8}</div></div></div>;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== onOpenChange || $[12] !== showModal) {
    t10 = showModal && <Button variant="default" onPress={() => onOpenChange?.(false)} className="w-full">Go Back to Complete</Button>;
    $[11] = onOpenChange;
    $[12] = showModal;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <div className="space-y-4">{t9}{t10}</div>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const content = t11;
  if (!showModal) {
    return validationErrors.length > 0 ? content : null;
  }
  if (isMobile) {
    let t12;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <SheetHeader><h2 className="text-xl font-semibold text-gray-900">Prerequisites Required</h2></SheetHeader>;
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    let t13;
    if ($[18] !== content) {
      t13 = <SheetContent side="bottom" className="max-h-[90vh] overflow-y-auto rounded-t-2xl p-6" closeButton={true}>{t12}<div className="mt-4">{content}</div></SheetContent>;
      $[18] = content;
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    let t14;
    if ($[20] !== isOpen || $[21] !== onOpenChange || $[22] !== t13) {
      t14 = <SheetOverlay isOpen={isOpen} onOpenChange={onOpenChange}>{t13}</SheetOverlay>;
      $[20] = isOpen;
      $[21] = onOpenChange;
      $[22] = t13;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    return t14;
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex flex-col gap-1.5 mb-4"><h2 className="text-xl font-semibold text-gray-900">Prerequisites Required</h2></div>;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== content) {
    t13 = <DialogContent className="max-w-lg" closeButton={true}>{t12}{content}</DialogContent>;
    $[25] = content;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isOpen || $[28] !== onOpenChange || $[29] !== t13) {
    t14 = <DialogOverlay isOpen={isOpen} onOpenChange={onOpenChange}>{t13}</DialogOverlay>;
    $[27] = isOpen;
    $[28] = onOpenChange;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}

// Validation helper function to check prerequisites
function _temp(error, index) {
  return <li key={index} className="flex items-start space-x-2 text-red-800"><span className="flex-shrink-0 w-1.5 h-1.5 bg-red-500 rounded-full mt-2" aria-hidden="true" /><span className="leading-relaxed">{error}</span></li>;
}
export function validatePrerequisites(state: Record<string, any>): string[] {
  const {
    address = {},
    basic = {},
    other = {}
  } = state || {};
  const errors: string[] = [];

  // Check if address location is set
  const location = address.location;
  if (!location || !location.coordinates || !location.city || !location.locality) {
    errors.push("Missing/Invalid location.");
  }
  if (!basic.price) errors.push("Missing price.");

  // Check if approach road width is filled (mandatory field from 'other' step)
  const approachRoadWidth = other.approachRoadWidth;
  if (!approachRoadWidth || approachRoadWidth <= 0) {
    errors.push("Missing approach road width.");
  }
  return errors;
}